export default {
    breadcrumbs: {
        home: 'Home',
        contact: 'Contact',
    },
    heading: 'Contact page',
    contact: 'Contact',
    contact_us: 'Contact us',
    description_1: 'It’s always great to hear from you.',
    description_2:
        'Fill out the form on the right side, and we’ll get back to you as soon as possible. During office hours, expect a response within 24 hours.',
    description_3:
        "If the problem can't wait that long, don't worry! We are dedicated and available outside of working hours for emergencies.",
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    support: 'Schedule a meeting',
}
